import { SurchargeScope, computeNightlySurcharge, parseIsoDateUtc } from './computeNightlySurcharge';
import { SurchargeGrids } from './types';

/** Adds whole days in UTC, so DST and browser timezone cannot shift the result. */
function addDays(checkIn: Date, days: number): string {
  const shifted = new Date(checkIn.getTime());
  shifted.setUTCDate(shifted.getUTCDate() + days);
  return shifted.toISOString().slice(0, 10);
}

/** Total surcharge for a stay, summing check-in through check-in + nights - 1. Checkout night excluded. */
export function computeStaySurcharge(
  checkInDate: string,
  nights: number,
  grids: SurchargeGrids,
  scope?: SurchargeScope,
): number {
  const checkIn = parseIsoDateUtc(checkInDate);
  if (checkIn == null || !Number.isInteger(nights) || nights <= 0) {
    return 0;
  }

  let total = 0;
  for (let night = 0; night < nights; night++) {
    total += computeNightlySurcharge(addDays(checkIn, night), grids, scope);
  }
  return total;
}

export function computeStaySurchargeByDate(
  stayStartDates: ReadonlyArray<string>,
  nights: number,
  grids: SurchargeGrids,
  scope?: SurchargeScope,
): Record<string, number> {
  const byDate: Record<string, number> = {};
  for (const date of stayStartDates) {
    byDate[date] = computeStaySurcharge(date, nights, grids, scope);
  }
  return byDate;
}
